module.exports = __webpack_public_path__ + "static/media/icon-profile_default.2e66f4a0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-profile_default.svg
// module id = ./src/assets/images/icon-profile_default.svg
// module chunks = 6